import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { CheckCircleIcon, ImageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
const BACKGROUNDS = [{
  id: 1,
  name: 'Showroom',
  category: 'Lifestyle'
}, {
  id: 2,
  name: 'Highway',
  category: 'Lifestyle'
}, {
  id: 3,
  name: 'Nature',
  category: 'Lifestyle'
}, {
  id: 4,
  name: 'City Streets',
  category: 'Lifestyle'
}, {
  id: 5,
  name: 'Blue Gradient',
  category: 'Abstract'
}, {
  id: 6,
  name: 'Red Gradient',
  category: 'Abstract'
}, {
  id: 7,
  name: 'Gold Gradient',
  category: 'Abstract'
}, {
  id: 8,
  name: 'Diwali',
  category: 'Festival'
}, {
  id: 9,
  name: 'Christmas',
  category: 'Festival'
}, {
  id: 10,
  name: 'Pongal',
  category: 'Festival'
}, {
  id: 11,
  name: 'Eid',
  category: 'Festival'
}, {
  id: 12,
  name: 'Modern Template',
  category: 'Brand'
}];
export function ChooseBackground() {
  const navigate = useNavigate();
  const [selectedBackground, setSelectedBackground] = useState<number | null>(null);
  const [filterCategory, setFilterCategory] = useState('all');
  const filteredBackgrounds = BACKGROUNDS.filter(bg => filterCategory === 'all' || bg.category === filterCategory);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1133">
      <Sidebar data-id="element-1134" />
      <main className="flex-1" data-id="element-1135">
        <Header data-id="element-1136" />
        <StepIndicator currentStep={2} steps={STEPS} data-id="element-1137" />
        <div className="px-6 py-8" data-id="element-1138">
          <div className="max-w-5xl mx-auto" data-id="element-1139">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1140">
              Step 2: Choose Background
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1141">
              Select an AI-generated background for your creative
            </p>

            <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-1142">
              <div className="flex items-center justify-between mb-6" data-id="element-1143">
                <h3 className="font-medium text-gray-800" data-id="element-1144">
                  Background Options
                </h3>
                <div className="flex space-x-2" data-id="element-1145">
                  {['all', 'Lifestyle', 'Abstract', 'Festival', 'Brand'].map(category => <button key={category} onClick={() => setFilterCategory(category)} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${filterCategory === category ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1146">
                        {category === 'all' ? 'All' : category}
                      </button>)}
                </div>
              </div>

              <div className="grid grid-cols-4 gap-4" data-id="element-1147">
                {filteredBackgrounds.map(bg => <button key={bg.id} onClick={() => setSelectedBackground(bg.id)} className={`p-3 rounded-lg border-2 transition-all ${selectedBackground === bg.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1148">
                    <div className="w-full h-28 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg mb-2 flex items-center justify-center" data-id="element-1149">
                      <ImageIcon className="text-gray-400" size={32} data-id="element-1150" />
                    </div>
                    <div className="flex items-center justify-between" data-id="element-1151">
                      <div className="text-left flex-1 min-w-0" data-id="element-1152">
                        <p className="font-medium text-gray-800 text-xs truncate" data-id="element-1153">
                          {bg.name}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-1154">{bg.category}</p>
                      </div>
                      {selectedBackground === bg.id && <CheckCircleIcon className="text-blue-500 flex-shrink-0 ml-2" size={18} data-id="element-1155" />}
                    </div>
                  </button>)}
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-1156">
              <h4 className="font-medium text-blue-900 mb-2" data-id="element-1157">
                AI-Generated Backgrounds
              </h4>
              <p className="text-sm text-blue-800" data-id="element-1158">
                All backgrounds are AI-generated and brand-approved. They
                automatically adapt to your selected product.
              </p>
            </div>

            <div className="flex justify-between" data-id="element-1159">
              <button onClick={() => navigate('/dealer/ai-generator/step-1')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1160">
                Back
              </button>
              <button onClick={() => navigate('/dealer/ai-generator/step-3')} disabled={!selectedBackground} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors" data-id="element-1161">
                Continue to Greetings
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}